import React, { useCallback, useState } from "react";
import makeStyles from "@mui/styles/makeStyles";
import { append, includes, not } from "ramda";
import { notBlank, notEmpty } from "../../../util/ext";

import SearchIcon from "@mui/icons-material/Search";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";

const useStyles = hasFilterMenu =>
  makeStyles(theme => ({
    toolbar: {
      display: "flex",
      alignItems: "center",
      height: 60,
      padding: hasFilterMenu ? theme.spacing(0, 4) : 0,
    },

    search: {
      backgroundColor: theme.palette.primary.light,
      borderRadius: "4px",
      position: "relative",
      width: "100%",
      display: "flex",
      alignItems: "center",
    },

    searchIcon: {
      color: theme.palette.primary.darker,
    },

    inputRoot: {
      color: theme.palette.primary.darker,
      flexGrow: 1,
      "&:hover .MuiOutlinedInput-notchedOutline": {
        border: `2px solid ${theme.palette.primary.brandPrimary}`,
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: `2px solid ${theme.palette.primary.brandPrimary}`,
      },
    },

    inputFocused: {
      borderColor: theme.palette.primary.brandPrimary,
    },

    outline: {
      borderColor: "transparent",
    },

    inputInput: {
      width: "100%",
      padding: theme.spacing(2.5),
    },
  }));

const ContentSearchBar = ({ query, onQueryChange, filterMenu }) => {
  const classes = useStyles(notBlank(filterMenu))();

  const [searchTerm, setSearchTerm] = useState("");

  const handleSearchTermChange = useCallback(
    event => {
      setSearchTerm(event.target.value);
    },
    [setSearchTerm],
  );

  const handleSearchTermEnterKey = useCallback(
    event => {
      if (event.key === "Enter") {
        if (notEmpty(searchTerm) && not(includes(searchTerm, query))) {
          onQueryChange(append(searchTerm, query));
          setSearchTerm("");
        }
      }
    },
    [searchTerm, query, onQueryChange, setSearchTerm],
  );

  return (
    <div className={classes.toolbar}>
      <div className={classes.search}>
        <OutlinedInput
          autoFocus
          type="search"
          placeholder="Search…"
          classes={{
            root: classes.inputRoot,
            input: classes.inputInput,
            notchedOutline: classes.outline,
            focused: classes.inputFocused,
          }}
          onChange={handleSearchTermChange}
          onKeyPress={handleSearchTermEnterKey}
          inputProps={{ "aria-label": "search" }}
          value={searchTerm}
          startAdornment={
            <InputAdornment position="start">
              <SearchIcon
                fontSize="large"
                classes={{ root: classes.searchIcon }}
              />
            </InputAdornment>
          }
        />
      </div>

      {notBlank(filterMenu) && filterMenu}
    </div>
  );
};

export default ContentSearchBar;
